// extracted by mini-css-extract-plugin
export default {"container":"uKRTn","recording":"ngUc0","recordingText":"cZ6ko","left":"Kk+vp","right":"xe4Q2","controlButtonText":"hlVkF"};